module.exports = __webpack_public_path__ + "img/page9.ab23f490.png";